export default "__VITE_ASSET__C1dbBa6F__"